<template>
  <div class="real-estate-wrapper">
    <SectionHeader
      v-if="mainRoute"
      v-model="searchQuery"
      title="realty"
      :subtitle="[menuRealty[0], menuRealty[1]]"
      :input-place-holder="'search'"
      @search-handler="findRC"
    />

    <section class="container">
      <template
        v-if="
          $route.query.genplanId ||
          $route.query.dfdSaves ||
          $route.query.dfdSaveCurrent ||
          $route.query.real_estate_with_houses ||
          $route.query.real_estate_with_apartments ||
          $route.query.house_uuid
        "
      >
        <div class="bread_crumb">
          <div class="bread_crumb__main-route name-route">
            <nuxt-link
              to="/real-estate"
              class="navigate-info-route"
              itemprop="item"
            >
              {{ $t('realty') }}
            </nuxt-link>
          </div>
          <template v-if="$route.query.secondaryPathName">
            <div class="icon includes" />
            <div
              :class="[
                'bread_crumb__second-route name-route',
                {active: !$route.query.tetriaryRouteName},
              ]"
              @click="
                $route.query.tetriaryRouteName && $router.go(-1)
              "
            >
              {{ $route.query.secondaryPathName }}
            </div>
          </template>
          <template v-if="$route.query.house_name">
            <div class="icon includes" />
            <div
              :class="[
                'bread_crumb__tetriary-route name-route',
                {active: !$route.query.house_name},
              ]"
              @click="
                $route.query.tetriaryRouteName && $router.go(-1)
              "
            >
              {{ $route.query.house_name }}
            </div>
          </template>
          <template v-if="$route.query.tetriaryRouteName">
            <div class="icon includes" />
            <div
              :class="[
                'bread_crumb__tetriary-route name-route',
                {active: !$route.query.fourRouteName},
              ]"
            >
              {{ $route.query.tetriaryRouteName }}
            </div>
          </template>
        </div>
        <div class="secondary-path">
          {{
            $route.query.tetriaryRouteName ||
            $route.query.secondaryPathName
          }}
        </div>
      </template>
      <transition name="fade-in-out" mode="out-in">
        <!--             $route.query.genplanId && $route.query.viewList === 'true' -->
        <div v-if="false">
          <!-- <GenplanFlatsList :flats-list="appartemtsForRealEstate" /> -->
        </div>
        <!-- отобразить текущую квартиру -->
        <div v-else-if="$route.query.dfdSaveCurrent">
          <DemoSavesDFDV2 />
        </div>

        <!-- отобразить жк -->
        <div v-else-if="$route.query.dfdSaves">
          <transition name="fade-in-out" mode="out-in">
            <DemoSavesDFD />
          </transition>
        </div>
        <div v-else-if="$route.query.real_estate_with_houses">
          <RealtySecondHouses
            v-if="houses_array.length !== 0"
            :list="houses_array"
            :uuid="$route.query.real_estate_with_houses"
            :name="nameSecondary"
          />
        </div>
        <div v-else-if="route.query.entrances === 'yes'">
          <GenplanNew :house="realtyWithGenPlan" />
        </div>
        <div
          v-else-if="
            $route.query.real_estate_with_apartments ||
            route.query.entrances === 'no'
          "
        >
          <RealtyFlats
            v-if="
              $route.query.real_estate_with_apartments ||
              route.query.entrances === 'no'
            "
            :flats-list="appartemtsForRealEstate"
          />
        </div>
        <div v-else>
          <transition name="fade-in-out">
            <div v-if="!route.query.secondaryPathName">
              <div
                v-if="real_estate_array_searched.length"
                class="real-estate-main"
              >
                <RealtyCard
                  v-for="realty in real_estate_array_searched"
                  v-show="realty.visible"
                  :key="realty.uuid"
                  :realty="realty"
                />
              </div>
              <div
                v-if="
                  !real_estate_array_searched.length &&
                  real_estate_array.length
                "
                class="real-estate-main"
              >
                <RealtyCard
                  v-for="realty in real_estate_array"
                  v-show="realty.visible"
                  :key="realty.uuid"
                  :realty="realty"
                />
              </div>
              <div
                v-if="!real_estate_array.length"
                class="real-estate-main"
              >
                <PreloadRealtyEstate
                  v-for="realty in Array(12)"
                  :key="realty"
                />
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </section>
  </div>
</template>

<script setup lang="ts">
import type {
  IRealty,
  IHouse,
  ISectionGenPlan,
} from '@/modules/RealEstate/api';
import {getAllRealty} from '@/modules/RealEstate/api';
import {
  getApartamentsForHouse,
  getApartamentsForRealty,
  getEntrances,
  getHouses,
} from '~/modules/RealEstate/controller';
import RealtyCard from '~/modules/RealEstate/components/RealtyCard.vue';
import RealtyFlats from '~/modules/RealEstate/components/RealtyFlats.vue';
import RealtySecondHouses from '~/modules/RealEstate/components/RealtySecondHouses.vue';
import GenplanNew from '~/modules/RealEstate/components/GenplanNew.vue';
import DemoSavesDFD from '~/modules/RealEstate/components/DemoSavesDFD.vue';
import {useLocale} from '~/plugins/Localization';
import PreloadRealtyEstate from '~/modules/RealEstate/components/PreloadRealtyEstate.vue';
import {getTranslateBySpanTag} from '~/helpers/baseFunction';
import {useI18n} from 'vue-i18n';
import DemoSavesDFDV2 from '~/modules/RealEstate/components/DemoSavesDFDV2.vue';
// import GenplanFlatsList from '~/modules/RealEstate/components/GenplanFlatsList.vue';

const {t} = useI18n();
const locale = useLocale();
const route = useRoute();

locale.getRealtyRequest();
locale.getCountriesRequest();

const real_estate_array: Ref<IRealty[]> = ref([]);
const real_estate_array_searched: Ref<IRealty[]> = ref([]);
const houses_array: Ref<IHouse[]> = ref([]);
const appartemtsForRealEstate: Ref<any[]> = ref([]);
const realtyWithGenPlan: Ref<ISectionGenPlan[]> = ref([]);

const searchQuery = ref('');

const menuRealty = computed(() =>
  getTranslateBySpanTag(t('menuRealtyDF')),
);

const mainRoute = computed(
  () => Object.keys(route.query).length === 0,
);

const nameSecondary = computed(
  () => route.query.secondaryPathName as string,
);

function findRC() {
  const matchingRCs = [];
  for (const rc of real_estate_array.value) {
    const translatedName = locale.getRealty(rc.name);
    console.debug();
    if (
      translatedName
        .toLowerCase()
        .includes(searchQuery.value.toLowerCase())
    ) {
      matchingRCs.push(rc);
    }
  }
  real_estate_array_searched.value = matchingRCs;
}
function getRealty() {
  getAllRealty().then((res) => {
    if (res.status === 'OK') {
      real_estate_array.value = res.data;
    }
  });
}

async function getList() {
  appartemtsForRealEstate.value = [];
  houses_array.value = [];
  realtyWithGenPlan.value = [];
  real_estate_array.value = [];
  if (route.query.real_estate_with_houses) {
    const data = await getHouses(
      route.query.real_estate_with_houses as string,
    );
    console.debug({data});
    houses_array.value = data;
  } else if (route.query.real_estate_with_apartments) {
    const data = await getApartamentsForRealty(
      route.query.real_estate_with_apartments as string,
    );
    appartemtsForRealEstate.value = data;
  } else if (route.query.house_uuid) {
    if (route.query.entrances === 'yes') {
      const data = await getEntrances(
        route.query.house_uuid as string,
      );
      realtyWithGenPlan.value = data;
    } else {
      const data = await getApartamentsForHouse(
        route.query.house_uuid as string,
      );
      appartemtsForRealEstate.value = data;
    }
  } else if (route.query.genplanId) {
    const data = await getApartamentsForHouse(
      route.query.genplanId as string,
    );
    appartemtsForRealEstate.value = data;
    console.debug(data);
  } else {
    getRealty();
  }
}
watch(
  () => route.query,
  (e) => {
    getList();
    if (Object.keys(e).length === 0) {
      appartemtsForRealEstate.value = [];
      realtyWithGenPlan.value = [];
      houses_array.value = [];
    }
  },
);
watch(
  () => route.query.real_estate_with_houses,
  () => {
    console.debug('u here');
    getList();
  },
);
watch(
  () => route.query.real_estate_with_apartments,
  async () => {
    const data = await getApartamentsForRealty(
      route.query.real_estate_with_apartments as string,
    );
    appartemtsForRealEstate.value = data;
  },
);
onMounted(async () => {
  await locale.getRealtyRequest();
  await locale.getCountriesRequest();

  getList();
});
</script>

<style lang="scss" scoped>
.mt-64 {
  margin-top: 64px !important;
}
.container {
  margin-top: 32px;
  margin-bottom: $m-5;
  .bread_crumb {
    display: flex;
    align-items: center;
    .icon {
      margin: 0 8px;
      height: 16px;
      width: 16px;
      &.includes {
        background: url('assets/svg/Right-arrow.svg');
      }
    }
    .name-route {
      cursor: pointer;
      color: #839aaf;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.28px;
      &.active {
        color: #64686e;
        font-weight: 700;
      }
    }

    @media (max-width: $md) {
      flex-wrap: wrap;
    }
  }
  .secondary-path {
    color: #3d424a;
    margin-top: 16px;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: 1.44px;
    margin-bottom: 32px;
  }
}
.real-estate-main {
  // margin-top: 96px;
  width: 100%;
  max-width: 1128px;
  min-height: 576px;
  margin: 0 auto 0;
  @include grid-card-center;
}
.title-wrapper {
  margin: 96px auto 0;
  width: 1128px;
  min-height: 166px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  & > .button {
    width: 189px;
    margin-top: 16px;
  }
  .title {
    height: 58px;
    color: var(--white-theme-black-100, #3d424a);
    font-family: Segoe UI;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 57.6px */
    letter-spacing: 1.44px;
  }
  .subtitle {
    height: 20px;
    color: var(--white-theme-gray-200, #839aaf);
    font-family: Segoe UI;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.28px;
  }
  .bread-crumbs {
    display: flex;
    gap: 8px;
    &__prev {
      height: 20px;
      color: var(--white-theme-gray-200, #839aaf);
      font-family: Segoe UI;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.28px;
      cursor: pointer;
    }
    .icon-right-arrow {
      cursor: pointer;
      height: 16px;
      width: 16px;
      align-self: center;
    }
    &__current {
      height: 20px;
      color: var(--white-theme-black-200, #64686e);
      font-family: Segoe UI;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.28px;
    }
  }
  .searchbar {
    width: 1128px;
    height: 40px;
    display: flex;
    gap: 16px;
    &-dash {
      align-self: center;
      width: 8px;
      stroke-width: 2px;
      stroke: var(--white-theme-gray-200, #839aaf);
      flex-shrink: 0;
    }
    &__flat-number {
      width: 204px;
    }
    .mok-select {
      border-radius: 8px;
      display: flex;
      width: 150px;
      padding: 10px 10px 10px 12px;
      background: #f4f6fd;
      color: var(--white-theme-gray-200, #839aaf);
      font-family: Segoe UI;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.28px;
    }
    &__range-quadrature {
      width: 220px;
      display: flex;
      gap: 8px;
    }
    &__range-coast {
      width: 284px;
      display: flex;
      gap: 8px;
    }
    &-reset {
      width: 40px;
      height: 40px;
      padding: 8px;
      border-radius: 8px;
      border: 1px solid var(--white-theme-white-400, #e1e5f0);
      display: flex;
      justify-content: center;
      align-items: center;
      align-self: stretch;
      cursor: pointer;
    }
  }
  .row-filters {
    width: 391px;
    height: 20px;
    display: flex;
    gap: 16px;
    &__item {
      display: flex;
      color: #839aaf;
      font-family: Segoe UI;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.28px;
      cursor: pointer;
      &.active {
        color: #2491e7;
        position: relative;
        margin-right: 10px;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          transform: translateX(100%);
          height: 20px;
          width: 20px;
          background-image: url(assets/svg/ArrowUp.svg);
          background-position: center;
          background-size: 16px;
        }
      }
      .icon-arrow-up {
        align-self: center;
        margin-left: 4px;
      }
    }
  }
}
</style>
